import React from 'react';
import { FlexBox, TabContent } from '@vp/swan';
import { CollaborationRequestCard } from '../components/CollaborationRequestCard';
import { DraftBriefs } from '../components/DraftBriefs';
import { Error } from '../components/Error';
import { JobCard } from '../components/JobCard';
import { MyDesigners } from '../components/MyDesigners';
import { PastProjects } from '../components/PastProjects';
import { ProcessingCard } from '../components/ProcessingCard';
import { ProjectsRequestCard } from '../components/ProjectsRequestCard';
import { CombinedProject } from '../hooks/useCombinedProjects';
import { DashboardEmptyState } from './DashboardEmptyState';

export function CombinedTabs({
    selectedTabId,
    currentRequests,
    pastRequests,
    projectsError,
}: {
    selectedTabId: 'current' | 'past' | 'draft' | 'myDesigners';
    currentRequests: CombinedProject[];
    pastRequests: CombinedProject[];
    projectsError?: Error;
}) {
    switch (selectedTabId) {
        case 'current':
            return (
                <TabContent tabId="current">
                    {projectsError ? (
                        <Error />
                    ) : currentRequests.length > 0 ? (
                        <FlexBox flexDirection="column" gap="between-subsections">
                            {currentRequests.map((r) => {
                                switch (r.type) {
                                    case 'Project':
                                        return (
                                            <ProjectsRequestCard key={r.value.id} {...r.value} />
                                        );
                                    case 'Collaboration':
                                        return (
                                            <CollaborationRequestCard
                                                key={r.value.url}
                                                {...r.value}
                                            />
                                        );
                                    case 'Request':
                                        return <JobCard key={r.value.id} request={r.value} />;
                                    case 'Processing':
                                        return (
                                            <ProcessingCard
                                                key={r.value.publicId}
                                                request={r.value}
                                            />
                                        );
                                    default:
                                        return null;
                                }
                            })}
                        </FlexBox>
                    ) : (
                        <DashboardEmptyState state="current" />
                    )}
                </TabContent>
            );
        case 'past':
            return (
                <TabContent tabId="past">
                    {projectsError ? (
                        <Error />
                    ) : pastRequests.length > 0 ? (
                        <PastProjects requests={pastRequests} />
                    ) : (
                        <DashboardEmptyState state="past" />
                    )}
                </TabContent>
            );
        case 'draft':
            return (
                <TabContent tabId="draft">
                    <DraftBriefs />
                </TabContent>
            );
        case 'myDesigners':
            return (
                <TabContent tabId="myDesigners">
                    <MyDesigners />
                </TabContent>
            );
    }
}
